/**
 * Show the runs used by a specific job version to allow user to select one.
 *
 * TODO: Do we want to truncate the run name if long?
 */

import React, {useState} from 'react';

import {TextField} from '../../Form/TextField';
import {formatTimestamp} from '../../Timestamp';
import {JobRun, JobRuns} from '../JobDetail/utilTypes';
import {ColorIndicator} from '../LinkRun';
import * as S from './SelectRunPanel.styles';

type SelectRunPanelProps = {
  runs: JobRuns;
  customRunColors: Record<string, string>;
  onSelectRun: (run: JobRun) => void;
  onClose: () => void;
};

export const SelectRunPanel = ({
  runs,
  customRunColors,
  onSelectRun,
  onClose,
}: SelectRunPanelProps) => {
  const [searchText, setSearchText] = useState('');
  const onSearchChange = (value: string) => {
    setSearchText(value);
  };
  const filteredRuns = searchText
    ? runs.filter(run => run.displayName.includes(searchText))
    : runs;

  const onClickRun = (run: JobRun) => {
    onSelectRun(run);
    onClose();
  };

  return (
    <S.Panel>
      <TextField
        placeholder="Search runs"
        value={searchText}
        onChange={onSearchChange}
      />
      <S.Spacer />
      <S.Runs>
        {filteredRuns.map(run => (
          <S.Run key={run.id} onClick={() => onClickRun(run)}>
            <S.RunNameRow>
              <ColorIndicator
                name={run.name}
                defaultColor={run.defaultColor}
                customRunColors={customRunColors}
              />
              <div>{run.displayName}</div>
            </S.RunNameRow>
            <S.Timestamp>{formatTimestamp(run.createdAt).short}</S.Timestamp>
          </S.Run>
        ))}
      </S.Runs>
    </S.Panel>
  );
};
